// @flow

import React, {createContext, useMemo} from 'react';

import type {ComponentType, Node, Context} from 'react';

import type {Subscribe} from '../typedef';


export type MouseObserverContextType = {|
    subscribe: Subscribe,
|};

const DEFAULT_CONTEXT = {
    subscribe: () => () => undefined
};

export const MouseObserverContext: Context<MouseObserverContextType> =
    createContext<MouseObserverContextType>(DEFAULT_CONTEXT);
MouseObserverContext.displayName = 'MouseObserverContext';

type Props = {|
    children: Node,
    ...MouseObserverContextType,
|};

export const MouseObserverProvider: ComponentType<Props> = (props: Props) => {
    const {
        children,
        subscribe
    } = props;

    const value = useMemo(() => ({
        subscribe
    }), [subscribe]);

    return <MouseObserverContext.Provider {...{value}}>{children}</MouseObserverContext.Provider>;
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
